<template>

    <div class="share-dialog-cover">

        <div class="puzzle-share-dialog-container">

            <img :src="images.return" class="psd-return" @click="returnToGame" />

            <p class="psd-detail"> —— 长按图片保存分享 —— </p>

            <img :src="images.poster" class="psd-image" />
        </div>        
    </div>
</template>

<script>

    import { reactive, toRefs } from "vue";
    import { useRouter } from "vue-router";

    import PosterImage from "@/assets/puzzle/share-dialog/poster.jpg";
    import ReturnBtn from "@/assets/puzzle/share-dialog/return-btn.png";

    export default {
        name: "PuzzleShareDialog",
        setup() {

            const router = useRouter();

            const state = reactive({
                images: {
                    poster: PosterImage,
                    return: ReturnBtn
                }
            });

            const returnToGame = () => {

                router.replace({
                    name: "Card"
                });
            };

            return {
                ...toRefs(state),
                returnToGame
            };
        }
    };
</script>

<style lang="scss" scoped>

    .share-dialog-cover {
        background: linear-gradient(0deg, #B5D5FC, #DEF5F7);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
    }

    .psd-image {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .psd-return {
        position: fixed;
        left: 0.5rem;
        top: 1rem;
    }

    .psd-detail {
        color: #686D74;
        position: fixed;
    }

    @media screen and (min-height: 800px) {
        
        .psd-image {
            width: calc(1125px / 3.2);
            height: calc(1806px / 3.2);
            position: relative;
            top: 25.3rem;
            transform: translate(-50%, -50%);
        }

        .psd-return {
            width: 6rem;
        }

        .psd-detail {
            top: calc(11%);
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            text-align: center;
        }
    }

    @media screen and (max-height: 800px) {
        
        .psd-image {
            width: calc(1125px / 3.8);
            height: calc(1806px / 3.8);
            position: relative;
            top: 20.3rem;
            transform: translate(-50%, -50%);
        }

        .psd-return {
            width: 23%;
        }

        .psd-detail {
            top: 10%;
            left: 50%;
            font-size: 0.8rem;
            transform: translate(-50%, -50%);
            width: 100%;
            text-align: center;
        }
    }
</style>